import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SharedModule } from '@aiwyn/shared';

/**
 * Overlay title block: a section eyebrow ("Section Title") and the
 * `A.2 Request Item Name` heading. Purely presentational.
 *
 * The title carries no status of its own. The panel says where the item stands
 * through its own content — the action row ("Marked as Finished" + Undo, or the
 * N/A note), the alert banner, and the documents/answer area — which is both
 * more specific than a label and what the design shows.
 */
@Component({
  selector: 'cxp-crl-overlay-title',
  templateUrl: './crl-overlay-title.component.html',
  styleUrls: ['./crl-overlay-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule],
})
export class CrlOverlayTitleComponent {
  readonly sectionName = input<string | null>(null);
  readonly displayNumber = input<string | null>(null);
  readonly itemTitle = input<string | null>(null);
}
